export var getSiteFontSize = function (style, referenceName) {
    return style.siteTextPresets[referenceName] ? style.siteTextPresets[referenceName].size : null;
};
export var getSettingsFontSize = function (style, settingsKey) {
    return style.styleParams.fonts[settingsKey] ? style.styleParams.fonts[settingsKey].size + "px" : null;
};
export var getFontSize = function (style, defaultSiteFont, settingsKey) {
    return getSettingsFontSize(style, settingsKey) || getSiteFontSize(style, defaultSiteFont);
};
export var getSettingsColor = function (style, settingsKey, forceOpacity) {
    var colors = style.styleParams.colors;
    var colorValue = colors[settingsKey] ? colors[settingsKey].value : null;
    if (!colorValue) {
        return null;
    }
    var rgba = parseRgba(colorValue, forceOpacity) || parseColorCode(colorValue, forceOpacity) || null;
    return rgba ? "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a + ")" : null;
};
export var getSiteColor = function (style, referenceName, forceOpacity) {
    var colorMap = getSiteColorMap(style);
    var rgba = parseColorCode(colorMap[referenceName], forceOpacity);
    return rgba ? "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a + ")" : null;
};
export var getColorStyle = function (style, ruleName, defaultSiteColor, settingsKey, forceOpacity) {
    var _a;
    var color = (settingsKey && getSettingsColor(style, settingsKey, forceOpacity)) ||
        getSiteColor(style, defaultSiteColor, forceOpacity);
    return color ? (_a = {}, _a[ruleName] = color, _a) : {};
};
var getSiteColorMap = function (style) {
    var map = {};
    style.siteColors.forEach(function (colorInfo) {
        map[colorInfo.reference] = colorInfo.value;
    });
    return map;
};
var parseRgba = function (rgbaString, forceOpacity) {
    var match = /^rgba?\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)(\s*,\s*([0-9]+(\.[0-9]+)?))?\s*\)$/i.exec(rgbaString);
    if (match) {
        var opacity = forceOpacity || match[5];
        if (Object.is(opacity, undefined)) {
            opacity = 1;
        }
        return {
            r: parseInt(match[1], 10),
            g: parseInt(match[2], 10),
            b: parseInt(match[3], 10),
            a: opacity,
        };
    }
    return null;
};
var parseColorCode = function (colorCode, opacity) {
    if (opacity === void 0) { opacity = 1; }
    var match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorCode);
    return match
        ? {
            r: parseInt(match[1], 16),
            g: parseInt(match[2], 16),
            b: parseInt(match[3], 16),
            a: opacity,
        }
        : null;
};
//# sourceMappingURL=style.js.map